import { useEffect, useState } from 'react';
import { walletApi } from '@/api/wallet';
import { chargingApi } from '@/api/charging';
import { amenitiesApi, type AmenitySessionOut } from '@/api/amenities';
import { useWalletStore } from '@/store/wallet';
import { useSessionStore } from '@/store/session';
import { ActiveSessionAlert } from '@/components/home/ActiveSessionAlert';
import { ActiveVacuumAlert } from '@/components/home/ActiveVacuumAlert';
import {
  WalletBalanceCard,
  WalletCardsRow,
  WalletCashbackCard,
  WalletMovementsRow
} from '@/components/wallet/WalletCards';
import { cardsApi, type SavedCard } from '@/api/cards';
import { Display, Eyebrow } from '@/components/ui/Typography';
import { friendlyMessage } from '@/lib/errors';

/**
 * Tela Carteira — redesign "Bow Carteiras" (T1): card Saldo principal +
 * carteira cashback + linha "Ver movimentações". A lista de transações
 * recentes saiu daqui — mora no /history.
 */
export default function Wallet() {
  const wallet = useWalletStore((s) => s.wallet);
  const setWallet = useWalletStore((s) => s.setWallet);
  const active = useSessionStore((s) => s.active);
  const setActive = useSessionStore((s) => s.setActive);

  const [error, setError] = useState<string | null>(null);
  const [activeVacuum, setActiveVacuum] = useState<AmenitySessionOut | null>(null);
  // `null` = backend sem cartão (rota ausente ou flag off) → a linha some.
  const [cards, setCards] = useState<SavedCard[] | null>(null);
  // Indique e Ganhe — `null` = backend sem a rota / erro; `enabled=false` =
  // programa desligado. Nos dois casos o card some.

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [walletData, activeSession, activeVac, savedCards] = await Promise.all([
          walletApi.get(),
          chargingApi.active(),
          // Acessório: falhar aqui não pode derrubar a carteira.
          amenitiesApi.activeSession().catch(() => null),
          cardsApi.list().catch(() => null)
        ]);
        if (cancelled) return;
        setWallet(walletData);
        setActive(activeSession);
        setActiveVacuum(activeVac);
        setCards(savedCards);
      } catch (err) {
        if (cancelled) return;
        setError(friendlyMessage(err, 'Falha ao carregar'));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [setWallet, setActive]);


  return (
    <div className="flex flex-col gap-5">
      <header className="pt-1">
        <Eyebrow>Sua carteira</Eyebrow>
        <Display size={28} className="mt-1">
          Saldo
        </Display>
      </header>

      <WalletBalanceCard wallet={wallet} />

      {active && <ActiveSessionAlert session={active} />}

      {activeVacuum && <ActiveVacuumAlert session={activeVacuum} />}

      <WalletCashbackCard wallet={wallet} />

      <WalletMovementsRow />

      {cards !== null && <WalletCardsRow count={cards.length} />}

      {error && (
        <div className="rounded-3xl bg-white p-5 shadow-soft">
          <p className="text-sm text-bow-red">{error}</p>
        </div>
      )}
    </div>
  );
}
